<app-pr-percentage *ngIf="renderAs==='percentage'" [params]="params"></app-pr-percentage>
<app-pr-currency *ngIf="renderAs==='currency'" [params]="params"></app-pr-currency>




